import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getCurrentFinancialYear, getCurrentFinancialYearSingle } from "../../../services/utils";
import styles from "../AdminExport.module.css";
import "./Antd.css";

const Filter = ({ onYearChange, yearValue, filterBy, contentType, setYear }) => {
  const { Option } = Select;

  const [displayYear, setDisplayYear] = useState();

  useEffect(() => {
    setYear(displayYear);
  }, [displayYear, contentType]);

  useEffect(() => {
    if (contentType === "PDP" || contentType === "Objectives") {
      setDisplayYear(getCurrentFinancialYearSingle());
    } else {
      setDisplayYear(getCurrentFinancialYear());
    }
  }, [contentType]);

  const finYears = [];
  const baseYear = 2020;
  const currentYear = new Date().getFullYear();

  // eslint-disable-next-line no-plusplus
  for (let i = baseYear; i <= currentYear; i++) {
    const nextYear = i + 1;
    const currYrTwoDigit = `${i + 1}`.toString().substring(2, 4);
    const currFinYear = `${i}/${currYrTwoDigit}`;
    const singleYearCurrent = `${i}`;
    const singleYearFuture = `${nextYear}`;
    const nextYrTwoDigit = `${nextYear + 1}`.toString().substring(2, 4);
    const nextFinYear = `${nextYear}/${nextYrTwoDigit}`;
    if (finYears.length <= 12) {
      if (contentType === "PDP" || contentType === "Objectives") {
        if (finYears.indexOf(singleYearCurrent) === -1) finYears.push(singleYearCurrent);
        if (finYears.indexOf(singleYearFuture) === -1) finYears.push(singleYearFuture);
      } else {
        if (finYears.indexOf(currFinYear) === -1) finYears.push(currFinYear);
        if (finYears.indexOf(nextFinYear) === -1) finYears.push(nextFinYear);
      }
    }
  }

  return (
    <>
      <span className={styles.label}>Filter by {filterBy}:</span>
      <Select
        placeholder={yearValue}
        style={{ width: 110 }}
        value={yearValue || displayYear}
        onChange={onYearChange}
      >
        <Option disabled hidden value="" style={{ color: "#727272" }}>
          {yearValue}
        </Option>
        {finYears.map((year) => {
          return (
            <Option key={year} value={year}>
              {year}
            </Option>
          );
        })}
      </Select>
    </>
  );
};

export default Filter;
